import React from 'react';

export const TvIconLine = (props: React.SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" stroke="currentColor" viewBox="0 -2 24 24" {...props}>
    <title>Televisie</title>
    <g fill="none" strokeLinecap="round" strokeWidth="1.5" clipPath="url(#a)">
      <path d="M.75 8.75c0-3.77 0-5.66 1.17-6.83S4.98.75 8.75.75h4c3.77 0 5.66 0 6.83 1.17s1.17 3.06 1.17 6.83 0 5.66-1.17 6.83-3.06 1.17-6.83 1.17h-4c-3.77 0-5.66 0-6.83-1.17S.75 12.52.75 8.75ZM14.75 20.75c-1.18-.64-2.54-1-4-1s-2.82.36-4 1" />
    </g>
    <defs>
      <clipPath>
        <path fill="#fff" d="M0 0h21.5v21.5H0z" />
      </clipPath>
    </defs>
  </svg>
);
